import { render, staticRenderFns } from "./TituloPrecos.vue?vue&type=template&id=648b4c62&"
import script from "./TituloPrecos.vue?vue&type=script&lang=js&"
export * from "./TituloPrecos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports